import { Sparkles } from "lucide-react";

interface Props {
  displayName: string;
}

export default function StepWelcome({ displayName }: Props) {
  return (
    <div className="space-y-4">
      <div className="flex items-start gap-3">
        <div className="mt-0.5 flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10 text-primary">
          <Sparkles className="h-5 w-5" />
        </div>
        <div>
          <h2 className="text-xl font-semibold tracking-tight">
            Welcome aboard{displayName ? `, ${displayName}` : ""}!
          </h2>
          <p className="text-sm text-muted-foreground mt-1">
            Let's spend two minutes setting up your workspace. We'll capture
            your company profile, your default Phase&nbsp;I ESA template, and
            optionally your first site — then auto-configure the dashboard
            and report wizard around them.
          </p>
        </div>
      </div>
      <ul className="text-sm text-muted-foreground space-y-2 ml-1">
        <li className="flex items-start gap-2">
          <span className="mt-1 h-1.5 w-1.5 rounded-full bg-primary shrink-0" />
          <span>You can skip any step or run setup again later from Settings → Account.</span>
        </li>
        <li className="flex items-start gap-2">
          <span className="mt-1 h-1.5 w-1.5 rounded-full bg-primary shrink-0" />
          <span>Nothing is shared with anyone else — every preference is scoped to your account.</span>
        </li>
        <li className="flex items-start gap-2">
          <span className="mt-1 h-1.5 w-1.5 rounded-full bg-primary shrink-0" />
          <span>If you provide a first site, a draft Phase&nbsp;I ESA report will be created automatically.</span>
        </li>
      </ul>
    </div>
  );
}
